module.exports = __webpack_public_path__ + "filesFromWebpack/src/assets/myfiles/conformity-declaration.PDF";